import { Movies, ReportUnit } from '@models';

export interface Scene {
  name: string;
  nameLanguageKey: string;
  description: string;
  groupName: string;
  sceneSectionName: string;
  sceneSectionNameLanguageKey: string;
  sceneSectionIdentifier: string;
  imageBlobUrl: string;
  reportSections: ReportSection[];
  simulationPreferences: [];
  descriptionItems: DescriptionItem[];
  movies: Movies[];
  identifier: string;
  recordingPath: string;
}

interface ReportSection {
  name: string;
  nameLanguageKey: string;
  reportItems: ReportItem[];
  identifier: string;
}

export interface ReportItem {
  name: string;
  nameLanguageKey: string;
  description: string;
  descriptionLanguageKey: string;
  maxValue: number;
  minValue: number;
  maxScore: number;
  noScore: boolean;
  goalValueString: string;
  unit: ReportUnit;
  bestIs: string;
  displayMode: string;
  scoreMappingFunctionEntries: [];
  identifier: string;
  id?: string;
  value?: number;
  goalValue?: string;
  score?: number;
}

interface DescriptionItem {
  header: string;
  content: string;
  imageUrl: string;
  movieUrl: string;
  tag: string;
}

export interface ReportScene {
  metric: string;
  nameMetric: string;
  value: number;
  unit: string;
}
